// extracted by mini-css-extract-plugin
export default {"form":"styles_form__Pbx98","error":"styles_error__W1KdO","title":"styles_title__56J4f"};